import { UTCDateTime } from './UTCDateTime';
import { CustomPasswordComponent } from './password';
const customComponentsMapping = {
    datetime: UTCDateTime,
    customPassword: CustomPasswordComponent
};
export { customComponentsMapping, UTCDateTime };
